import Link from "antd/es/typography/Link";
import { tableDoDontSchema, tableSchema } from "../../../services/Item";
import { Tool } from "../../../services/Tool";
import UrlParser from "../../urlParser/urlParser"
import { Tooltip } from "antd";

export const getTableColumns = (start: number) => [
    {
        title: '#', dataIndex: 'order', key: 'order', width: '5%', render: (text: any, record: tableSchema, index: number) => (
            index + start
        )
    },
    {
        title: 'Action to be taken', dataIndex: 'action', key: 'action', width: '15%', render: (text: any, record: tableSchema) => (
            UrlParser({ text: record.action })
        )
    },
    {
        title: 'Application / Tool', dataIndex: 'application', key: 'application', width: '10%', className: 'responsible-column', render: (text: any, record: tableSchema) => (
            <div className="printable-tool" style={{ background: (record.application as Tool)?.color || 'inherit', height: '100%', padding: 8 }}>{(record.application as Tool)?.title}</div>
        )
    },
    {
        title: 'Responsible', dataIndex: 'responsible', key: 'responsible', width: '20%', render: (text: any, record: tableSchema) => (
            UrlParser({ text: record.responsible })
        )
    },
    {
        title: 'Timeline', dataIndex: 'triggerStage', key: 'triggerStage', width: '10%', render: (text: any, record: tableSchema) => (
            UrlParser({ text: record.triggerStage })
        )
    },
    {
        title: 'Comments', dataIndex: 'comments', key: 'comments', width: '25%', render: (text: any, record: tableSchema) => (
            UrlParser({ text: record.comments })
        )
    },
    {
        title: 'Links', dataIndex: 'links', key: 'links', width: '15%', render: (text: any, record: tableSchema) => (
            <div>
                {record.links?.map((link, index) => (<div style={{paddingBottom: 6}}>
                    <Tooltip title={link?.link?.length > 150 ? `${link?.link?.substring(0, 150)}...` : link?.link}>
                        <Link key={index} href={link?.link} target="_blank">
                            {link?.title}
                        </Link>
                    </Tooltip>
                </div>))}
            </div>
        )
    },
];


export const TABLE_DO_DONT_COLUMNS = [
    {
        title: '#', dataIndex: 'order', key: 'order', width: '6%', render: (text: any, record: tableDoDontSchema, index: number) => (
            index + 1
        )
    },
    {
        title: 'DO', dataIndex: 'do', key: 'do', width: '43%', render: (text: any, record: tableDoDontSchema) => (
            record.do
        )
    },
    {
        title: "DON'T", dataIndex: 'dont', key: 'dont', width: '43%', render: (text: any, record: tableDoDontSchema) => (
            record.dont
        )
    },
];
